import React, { useState, useEffect } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Button, Grid, TextField, Typography } from "@material-ui/core";
import FactorySelect from "../../_shared/FactorySelect";
import PropTypes from "prop-types";
import PlantSelect from "../../_shared/PlantSelect";
import FormControlWrapper from "../../_shared/FormControlWrapper";
import { ExpandMore } from "@material-ui/icons";

const IEDistributionListFilters = (props) => {
    const labelMinWidth = 85
    const [filtersAccordion, setFiltersAccordion] = useState(true)

    useEffect(() => {
        if (props.plants?.length === 1)
            props.onPlantChange(props.plants[0].id)
    }, [props.plants?.length])

    useEffect(() => {
        if (props.factories?.length === 1)
            props.onFactoryChange(props.factories[0].id)
    }, [props.filterState.plantId.value, props.factories])

    return (
        <Accordion
            className="appAccordion"
            expanded={filtersAccordion}
            onChange={(e, expanded) => setFiltersAccordion(expanded)}
        >
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography>Filters</Typography>
            </AccordionSummary>
            <AccordionDetails className="contentPadding">
                <Grid container spacing={3} className="appFilterContainer">
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Plant" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterState.plantId.isRequired}>
                            <PlantSelect
                                plants={props.plants}
                                error={!!props.filterState.plantId.error}
                                selectedValue={props.filterState.plantId.value}
                                onPlantChange={(value) => props.onPlantChange(value)} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Factory" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterState.factoryId.isRequired}>
                            <FactorySelect
                                factories={props.factories}
                                error={!!props.filterState.factoryId.error}
                                selectedValue={props.filterState.factoryId.value}
                                onFactoryChange={(value) => props.onFactoryChange(value)} />
                        </FormControlWrapper>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} className="appButtonGroup">
                        <Button variant="contained" onClick={props.onFilterClear}>Clear</Button>
                        <Button
                            color="primary"
                            variant="contained"
                            onClick={props.updatePerWeekHours}>Save</Button>
                    </Grid>
                    <Grid container item xs={12} sm={12} md={6} lg={3} justify="flex-end" alignContent="center">
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={props.onOpenIEDistribution}
                        >Add IE Distribution</Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={3} >
                        <FormControlWrapper label="Per Day Hours" variant="inline" labelMinWidth={labelMinWidth} isRequired={props.filterState.perWeekHours.isRequired}>
                            <TextField
                                value={
                                    props.filterState.perWeekHours.value
                                        ? Math.abs(parseFloat(props.filterState.perWeekHours.value.toString()))
                                        : ""
                                }
                                size='small'
                                variant="outlined"
                                fullWidth
                                type={"number"}
                                inputProps={{ min: 0 }}
                                error={!!props.filterState.perWeekHours.error}
                                disabled={!props.filterState.factoryId.value && !props.filterState.factoryCode.value}
                                onChange={(event) => props.onPerWeekHourChange(event.target.value)} />
                        </FormControlWrapper>
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>

    )
}

IEDistributionListFilters.propTypes = {
    plants: PropTypes.array.isRequired,
    factories: PropTypes.array.isRequired,
    onOpenIEDistribution: PropTypes.func,
    filterState: PropTypes.object,
    onPlantChange: PropTypes.func,
    onFactoryChange: PropTypes.func,
    onPerWeekHourChange: PropTypes.func,
    updatePerWeekHours: PropTypes.func,
    onFilterClear: PropTypes.func,
}
IEDistributionListFilters.defaultProps = {
    plants: []
}

export default IEDistributionListFilters;
